import React, { useState } from 'react';
import { FormGroup, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faBan, faSave, faTrashAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

function NewUserCard(props) {
    //const [user, setUser] = useState(props.user);

    const updateUser = (e) => {
        console.log('updating user...');
        //setUser({ ...user, [e.target.name]: e.target.value });
        props.update(props.user, e);
    };

    const cancel = () => {
        props.cancel(props.user.userID);
    };

    const save = () => {
        console.log('Saving user...');
        props.save(props.user);
    };

    const userJSX = (
        <div className="user card  item-details">
            <div className="properties">
                <InputGroup>
                    <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <FontAwesomeIcon icon={faEnvelope} />
                        </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="Email" name="emailAddress" value={props.user.emailAddress || ''} onChange={updateUser} list="emailSearchList" />
                    <datalist id="emailSearchList">
                        {props.allUsers.map(u => (<option key={u.userID} value={u.emailAddress}>{u.emailAddress}</option>))}
                    </datalist>
                </InputGroup>
            </div>
            <div className="actions-horizontal">
                <div onClick={cancel} className="action-icon action-delete">
                    <FontAwesomeIcon icon={faBan} />
                </div>
                <div onClick={save} className="action-icon action-add">
                    <FontAwesomeIcon icon={faSave} />
                </div>
            </div>
        </div>
    );

    return userJSX;
}

export default NewUserCard;